import { captureException } from '@sentry/nuxt';
import { GetManagementUrlRequest } from 'gportal-grpc/gportal/api/payment/v1/requests_pb';
import { PaymentProvider } from 'gportal-grpc/gportal/type/v1/payment_pb';

// The portal URL is minted per click by GetManagementUrl, so it cannot be hardcoded.
export default () => {
  const { t } = useI18n();
  const { pushErrorNotification } = useNotifications();
  const $grpcPayment = useGrpcPayment();
  // executeApiCallActive does not attach auth on its own, so the header is passed explicitly.
  const buildAuthMetadata = useAuthMetadata();
  const opening = ref(false);

  async function openPortal() {
    if (opening.value) return;
    opening.value = true;

    // Opened before the await so the browser ties it to the click and does not block it.
    const tab = window.open('', '_blank');
    if (tab) tab.opener = null;

    try {
      const { response, error } = await $grpcPayment.executeApiCallActive(
        'getManagementUrl',
        new GetManagementUrlRequest({ provider: PaymentProvider.CHARGEBEE }),
        buildAuthMetadata(),
      );

      const url = response?.url;
      // Only a well-formed absolute https:// URL may reach the tab.
      let portalUrl: URL | null = null;
      try {
        portalUrl = url ? new URL(url) : null;
      } catch {
        // A malformed URL is handled by the failure branch below.
      }
      if (error != null || portalUrl?.protocol !== 'https:') {
        tab?.close();
        captureException(
          error ?? new Error('GetManagementUrl returned an invalid URL'),
        );
        pushErrorNotification({
          title: t('general/error/title'),
          message: t('account/payments/chargebee/portal_error'),
        });
        return;
      }

      if (tab) tab.location.href = portalUrl.href;
      else window.open(portalUrl.href, '_blank', 'noopener,noreferrer');
    } finally {
      opening.value = false;
    }
  }

  return { openPortal, opening };
};
